/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import { Row, Col, Button, Table, Card, CardBody } from "reactstrap";
import dayjs from "dayjs";
import logo from "../../Assets/images/logo.png";
import { getCookie } from "../../Helpers/Utils";
import { toast } from "react-toastify";

const InvoiceView = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [data, setData] = useState(null);

    const loadInvoice = async () => {
        dispatch(loadingTrue());
        // URL remains same as your ref api call
        const res = await Handler({ method: "get", url: `/invoice/view_new.php?invoice_id=${id}` });

        // ⭐ Updated logic to match your new JSON response structure
          console.log("Loaded Invoice Data:", res); 
        if (res?.success) { 
            setData(res); 
            console.log("Loaded Invoice Data:", res); // Debug log to verify data structure
        } else {
            toast.error(res?.message || "Invoice not found");
        }
        dispatch(loadingFalse());
    };

    const handlePdfPrint = () => {
        const token = getCookie("token");
        dispatch(loadingTrue());

        fetch(`${process.env.REACT_APP_API_URL || "https://sfs.software.dizoratbd.com/vehicle_pos"}/invoice/manual_generate.php`, {
        // fetch(`${process.env.REACT_APP_API_URL || "http://localhost/pos"}/invoice/manual_generate.php`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify({ invoice_id: id })
        })
        .then(res => {
            if (!res.ok) throw new Error("Failed to generate PDF");
            return res.blob();
        })
        .then(blob => {
            const url = URL.createObjectURL(blob);
            const printWindow = window.open(url, '_blank');
            if (printWindow) {
                printWindow.onload = () => {
                    setTimeout(() => {
                        printWindow.focus();
                        printWindow.print();
                    }, 500);
                };
            }
            dispatch(loadingFalse());
        })
        .catch(err => {
            toast.error("Error generating professional print");
            dispatch(loadingFalse());
        });
    };

    useEffect(() => { loadInvoice(); }, [id]);

    if (!data) return null;

    // ⭐ Destructuring based on your response
    const { invoice, customer, items, payments } = data?.data || {};

    return (
        <div className="invoice-view-container p-4 bg-light min-vh-100">
            {/* Action Bar */}
            <div className="d-flex justify-content-between align-items-center mb-4 no-print">
                <Button color="secondary" className="px-4 border shadow-sm" onClick={() => navigate(-1)}>
                    <i className="bi bi-arrow-left me-2"></i> Back
                </Button>
                <Button color="primary" className="px-4 shadow-sm" onClick={handlePdfPrint}>
                    <i className="bi bi-printer me-2"></i> Print Invoice
                </Button>
            </div>

            {/* Main Invoice Sheet */}
            <Card className="shadow-lg border-0 mx-auto" style={{ maxWidth: "900px", padding: "10px" }}>
                <CardBody>
                    {/* Header Section */}
                    <div className="d-flex justify-content-between align-items-start mb-5 border-bottom pb-4">
                        <div>
                            <img src={logo} alt="SFS Logo" style={{ height: "75px", marginBottom: "15px" }} />
                            <h4 className="fw-bold text-dark mb-1">SEA FREIGHT SOLUTIONS PTE LTD</h4>
                            <p className="small text-muted mb-0">1 Sunview Road, #04-20 Eco-Tech @Sunview, Singapore 627615</p>
                            <p className="extra-small text-muted">Tel: +65 8672 4777 | sales@seafreightsolutions.sg</p>
                        </div>
                        <div className="text-end">
                            <h2 className="fw-light text-primary uppercase tracking-widest mb-3" style={{ fontSize: '2.4rem' }}>INVOICE</h2>
                            <p className="mb-0 text-dark small"><strong>Invoice No:</strong> {invoice?.invoice_number}</p>
                            <p className="mb-0 text-dark small"><strong>Date:</strong> {dayjs(invoice?.issued_date).format("DD/MM/YYYY")}</p>
                            <p className="mb-0 text-dark small"><strong>Vessel:</strong> {invoice?.vessel_name || "N/A"}</p>
                        </div>
                    </div>

                    {/* Customer Info Section */}
                    <Row className="mb-5">
                        <Col md={7}>
                            <p className="mb-1 fw-bold text-muted small text-uppercase tracking-wider">BILL TO:</p>
                            <h5 className="fw-bold text-primary mb-1">{customer?.company_name}</h5>
                            <div className="small text-muted mb-2" style={{ whiteSpace: 'pre-line', maxWidth: '300px' }}>
                                {customer?.billing_address}
                            </div>
                            <p className="small text-dark mb-0"><strong>Attn:</strong> {customer?.contact_person}</p>
                            <p className="small text-dark"><strong>Tel:</strong> {customer?.phone}</p>
                        </Col>
                        <Col md={5}>
                            <div className="bg-light p-3 rounded border text-end">
                                <p className="mb-1 small"><strong>DO No:</strong> {invoice?.dispatch_number ? invoice.dispatch_number : (invoice?.quotation_id ? `DO-${invoice.quotation_id}` : 'N/A')}</p>
                                <p className="mb-1 small"><strong>Currency:</strong> {invoice?.currency}</p>
                                <p className="mb-0 small text-uppercase"><strong>Status:</strong> <span className={`fw-bold text-${invoice?.status === 'paid' ? 'success' : 'danger'}`}>{invoice?.status}</span></p>
                            </div>
                        </Col>
                    </Row>

                    {/* Line Items Table */}
                    {/* Line Items Table */}
                    <Table bordered responsive className="align-middle mb-5">
                        <thead className="table-dark text-uppercase" style={{ fontSize: '0.75rem' }}>
                            <tr>
                                <th width="15%" className="text-center">DO Date</th>
                                <th width="45%" className="text-start">Description</th>
                                <th width="10%" className="text-center">Qty</th>
                                <th width="15%" className="text-end">Rate (SGD)</th>
                                <th width="15%" className="text-end">Total (SGD)</th>
                            </tr>
                        </thead>
                        <tbody className="small">
                            {items?.map((item, index) => {
                                const timeDetails = [];
                                if (parseFloat(item.office_hrs) > 0 || parseFloat(item.office_hrs_ot) > 0) {
                                    timeDetails.push(`OFFICE: ${parseFloat(item.office_hrs).toFixed(2)}H / ${parseFloat(item.office_hrs_ot).toFixed(2)}OT`);
                                }
                                if (parseFloat(item.after_office_hrs) > 0 || parseFloat(item.after_office_hrs_ot) > 0) {
                                    timeDetails.push(`AFTER OFF: ${parseFloat(item.after_office_hrs).toFixed(2)}H / ${parseFloat(item.after_office_hrs_ot).toFixed(2)}OT`);
                                }
                                if (parseFloat(item.holiday) > 0 || parseFloat(item.holiday_ot) > 0) {
                                    timeDetails.push(`HOLIDAY: ${parseFloat(item.holiday).toFixed(2)}H / ${parseFloat(item.holiday_ot).toFixed(2)}OT`);
                                }

                                return (
                                    <tr key={index}>
                                        <td className="text-center">{dayjs(invoice?.issued_date).format("DD/MM/YYYY")}</td>
                                        <td className="text-start">
                                            <div className="fw-bold text-dark" style={{ fontSize: '1rem' }}>{item.lorry_type}</div>
                                            <div className="extra-small text-muted mb-1">
                                                COLLECTION FROM {item.pickup_location} TO {item.delivery_location}
                                            </div>
                                            {item.work_start_datetime && item.work_end_datetime && (
                                                <div className="extra-small text-muted font-monospace">
                                                    TIME: {dayjs(item.work_start_datetime).format("HHmm")} - {dayjs(item.work_end_datetime).format("HHmm")} HRS
                                                </div>
                                            )}
                                            {timeDetails.length > 0 && (
                                                <div className="mt-1 extra-small text-secondary">
                                                    {timeDetails.join(" | ")}
                                                </div>
                                            )}
                                            {item.vehicle_number && (
                                                <div className="mt-1 extra-small fw-bold text-primary">
                                                    REG NO: {item.vehicle_number}
                                                </div>
                                            )}
                                            {parseFloat(item.extra_charges) > 0 && (
                                                <div className="mt-1 extra-small text-warning fw-bold">
                                                    EXTRA CHARGES: ${parseFloat(item.extra_charges).toFixed(2)} 
                                                    {item.extra_charges_description && ` (${item.extra_charges_description})`}
                                                </div>
                                            )}
                                        </td>
                                        <td className="text-center">1</td>
                                        <td className="text-end">${parseFloat(item.line_total).toFixed(2)}</td>
                                        <td className="text-end fw-bold">${parseFloat(item.line_total).toFixed(2)}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>

                    {/* Summary Section */}
                    <Row className="justify-content-end mb-5">
                        <Col md={5}>
                            <div className="d-flex justify-content-between mb-2 small px-2">
                                <span className="text-muted">Sub Total</span>
                                <span className="fw-bold">${invoice?.amounts?.subtotal.toFixed(2)}</span>
                            </div>
                            <div className="d-flex justify-content-between mb-2 small px-2">
                                <span className="text-muted">GST ({invoice?.amounts?.gst_percent}%)</span>
                                <span className="fw-bold">${invoice?.amounts?.gst_amount.toFixed(2)}</span>
                            </div>
                            <div className="d-flex justify-content-between mb-3 small px-2">
                                <span className="text-muted">Total Paid</span>
                                <span className="fw-bold text-success">-${invoice?.amounts?.total_paid.toFixed(2)}</span>
                            </div>
                            <div className="d-flex justify-content-between p-3 bg-primary text-white rounded shadow-sm">
                                <h5 className="mb-0 uppercase small pt-1 font-letter-spacing">Balance Due</h5>
                                <h4 className="mb-0 fw-bold">${invoice?.amounts?.remaining_balance.toFixed(2)}</h4>
                            </div>
                        </Col>
                    </Row>

                    {/* Payment Info Section */}
                    <div className="p-4 border rounded bg-light" style={{ fontSize: '0.85rem' }}>
                        <h6 className="fw-bold text-uppercase border-bottom pb-2 mb-3 tracking-wider">Payment Instructions:</h6>
                        <Row>
                            <Col sm={7}>
                                <p className="mb-1"><strong>Beneficiary:</strong> SEA FREIGHT SOLUTIONS PTE LTD</p>
                                <p className="mb-1"><strong>Bank:</strong> OCBC (Oversea-Chinese Banking Corp)</p>
                                <p className="mb-0"><strong>Account No:</strong> 701-553786-001</p>
                            </Col>
                            <Col sm={5} className="text-sm-end mt-3 mt-sm-0">
                                <p className="mb-1"><strong>UEN / PayNow:</strong> 202602406G</p>
                                <p className="extra-small text-muted italic">Kindly indicate Invoice No. in remarks</p>
                            </Col>
                        </Row>
                    </div>

                    {/* Footer */}
                    <div className="mt-5 pt-4 text-center border-top">
                        <p className="small mb-1 italic">FOR SEA FREIGHT SOLUTIONS PTE LTD</p>
                        <div style={{ height: '40px' }}></div>
                        <p className="extra-small text-muted uppercase tracking-tighter">Computer Generated Invoice. No Signature Required.</p>
                    </div>
                </CardBody>
            </Card>

            {/* Custom Styles */}
            <style>
                {`
                    @media print {
                        .no-print { display: none !important; }
                        body { background: white !important; padding: 0 !important; }
                        .card { shadow: none !important; border: none !important; }
                    }
                    .extra-small { font-size: 0.75rem; }
                    .font-letter-spacing { letter-spacing: 1.5px; }
                    .italic { font-style: italic; }
                    .uppercase { text-transform: uppercase; }
                    .tracking-wider { letter-spacing: 1px; }
                `}
            </style>
        </div>
    );
};

export default InvoiceView;